import {openRogueApSection} from '../apSections/adapter';

/**
 * Canvas Access Point dashboard > Rogue AP.
 *
 * An accordion inside one Access Point, so the context is `ap` and the
 * workflow asks which Access Point when the request did not name one. The
 * page reports when the accordion is actually showing, which is what makes
 * this verified rather than merely registered.
 */
const rogueApPlugin = {
	id: 'rogue_ap',
	version: 1,
	commandVersion: 1,
	resource: 'rogue_ap',
	operations: ['view'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['ap.dashboard'],
	},
	sections: {
		'ap.rogue_ap': openRogueApSection,
	},
};

export default rogueApPlugin;
